import { PermissionsEnum } from "@/auth/interfaces";
import { CustomTabPanel } from "@/erp/sale";
import {
  a11yProps,
  EstadoFactibilidadCorporativaENUM,
  sizeTab,
  useCheckPermissionsArray
} from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TableSolicitudFactibilidadCorporativo from "../../shared/table_solicitud_factibilidad_corporativo/TableSolicitudFactibilidadCorporativo";

export default function SolicitudFactibilidadCorporativoPage() {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_factibilidadcoorporativa,
    PermissionsEnum.api_change_factibilidadcoorporativa,
  ]);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Solicitud Inventario Factibilidad Corporativa"}
      visibleReport={true}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Solicitudes'} {...a11yProps(0)} />
          <Tab label={'Pre Aprobadas'} {...a11yProps(1)} />
          <Tab label={'Aprobadas por Supervisor'} {...a11yProps(2)} />
          <Tab label={'Aprobadas'} {...a11yProps(3)} />
          <Tab label={'Fallido'} {...a11yProps(4)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudFactibilidadCorporativo
          estado_factibilidad={`${EstadoFactibilidadCorporativaENUM.PENDIENTE},${EstadoFactibilidadCorporativaENUM.INSPECCIONADO}`}
          aceptado_factibilidad={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudFactibilidadCorporativo
          estado_factibilidad={undefined}
          aceptado_factibilidad={true}
          preaprobado_inventario={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudFactibilidadCorporativo
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.EN_REVISION}
          aceptado_factibilidad={true}
          preaprobado_inventario={true}
          aprobado_supervisor={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <TableSolicitudFactibilidadCorporativo
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.APROBADO}
          aceptado_factibilidad={true}
          preaprobado_inventario={true}
          aprobado_supervisor={true}
          aprobado_inventario={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={4}>
        <TableSolicitudFactibilidadCorporativo
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.CANCELADO}
          aceptado_factibilidad={true}
          preaprobado_inventario={undefined}
          aprobado_inventario={undefined}
          aprobado_supervisor={undefined}
          canEditGlobal={false}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}
